import MetaRobots from 'components/Basic/Head/MetaRobots';
import { LegalGuaranteeNoticeContent } from 'components/Blocks/LegalGuaranteeNotice/LegalGuaranteeNoticeContent';
import CommonLayout from 'components/Layout/CommonLayout';
import { Webline } from 'components/Layout/Webline/Webline';
import { SettingsQueryDocumentApi } from 'graphql/generated';
import { createClient } from 'helpers/createClient';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import useTranslation from 'next-translate/useTranslation';
import { NextPageExtended } from 'types/global';

const LegalGuaranteeNoticePage: NextPageExtended<ServerSidePropsType> = () => {
    const { t } = useTranslation();

    return (
        <CommonLayout title={t('Harmonised notice (Legal guarantee)')}>
            <MetaRobots content="noindex" />
            <section aria-label={t('Harmonised notice (Legal guarantee)')}>
                <Webline>
                    <div className="flex justify-center overflow-auto py-8">
                        <LegalGuaranteeNoticeContent />
                    </div>
                </Webline>
            </section>
        </CommonLayout>
    );
};

LegalGuaranteeNoticePage.layout = 'plain';

export const getServerSideProps = getServerSidePropsWrapper(
    ({ domainConfig, redisClient, ssrExchange, t }) =>
        async (context) => {
            const client = createClient({
                publicGraphqlEndpoint: domainConfig.publicGraphqlEndpoint,
                ssrExchange,
                t,
                context,
                redisClient,
            });
            const serverSideProps = await initServerSideProps({
                client,
                context,
                domainConfig,
                ssrExchange,
                prefetchedQueries: [{ query: SettingsQueryDocumentApi }],
            });
            const settingsResponse = await client
                .query(SettingsQueryDocumentApi, {}, { requestPolicy: 'cache-only' })
                .toPromise();

            if (!settingsResponse.data?.settings?.isHarmonisedNoticeAllowed) {
                return { notFound: true };
            }

            return serverSideProps;
        },
);

export default LegalGuaranteeNoticePage;
